import React, { useEffect, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import i18next from "i18next";

import Container from '@material-ui/core/Container';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import DeleteIcon from '@material-ui/icons/Delete';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import Autocomplete from '@material-ui/lab/Autocomplete';

import Loader from '../_shared/Loader';
import useList from '../hooks/useList';
import httpClient from '../_shared/HttpClient';

//store
import { appStore } from '../../appStore.js';
import { Typography, ListItemAvatar, Avatar } from '@material-ui/core';


const useStyles = makeStyles(theme => ({
    okButton: {
        color: theme.palette.info.main,
    },
    formBox: {
        marginBottom: theme.spacing(2),
        padding: theme.spacing(1, 0),
    },
}));

const UserClaims = (props) => {
    const { t } = useTranslation();
    const classes = useStyles();
    const { id } = props;
    const { state, dispatch } = useContext(appStore);
    const [isLoading, setIsLoading, rows, setRows, hasMore, setHasMore] = useList('name');
    const [selected, setSelected] = useState(null);
    const [claimObject, setClaimObject] = useState('league');
    const [permission, setPermission] = useState('write');
    const [claimValue, setClaimValue] = useState('');
    const [claimSearchText, setClaimSearchText] = useState('');
    const [claimSuggestions, setClaimSuggestions] = useState([]);
    const [isSearchingSuggestions, setIsSearchingSuggestions] = useState(false);
    const [selectedSuggestion, setSelectedSuggestion] = useState(null);

    const take = 10;

    useEffect(() => {
        loadData();
    }, [id]);

    useEffect(() => {
        setClaimValue('');
        setClaimSearchText('');
        setClaimSuggestions([]);
        setSelectedSuggestion(null);
    }, [claimObject]);

    useEffect(() => {
        const timerId = setTimeout(() => {
            searchClaimTargets(claimSearchText);
        }, 250);

        return () => clearTimeout(timerId);
    }, [claimObject, claimSearchText]);

    const loadData = async (append) => {
        if (isLoading || (!hasMore && append) || !id) return;
        setIsLoading(true);
        const effectiveSkip = append ? (rows ? rows.length : 0) : 0;

        if (!append) {
            setRows([]);
        }
        try {
            var result = await httpClient('get', 'user/GetUserClaims', { skip: effectiveSkip, take: take, userID: id });

            if (append) {
                setRows([...rows, ...result])
            }
            else {
                setRows(result);
            }
            setHasMore(false);
        }
        catch (err) {
            console.log(err);
        }
        finally {
            setIsLoading(false);
        }
    };

    const handleDelete = async (e, i, row, userID) => {
        e.preventDefault();

        if (isLoading) return;

        try {
            setIsLoading(true);
            const result = await httpClient('delete', 'User/RemoveUserClaim', { claimObject: row.claimObject, value: row.value, userId: row.userId });
            if (result.errors) {
                // setErrors(result.errors);
            }
            else {
                await loadData(false);
            }
        }
        catch (e) {
            // setErrors([{ message: e }]);
        }
        finally {
            setIsLoading(false);
        }
    }

    const handleAddClaim = async () => {
        if (!id || !claimObject || !permission || !String(claimValue || '').trim()) return;

        try {
            setIsLoading(true);

            const payload = {
                userId: id,
                claimObject: claimObject,
                permission: permission,
                value: String(claimValue).trim(),
                isNew: true,
            };

            const result = await httpClient('post', 'User/UpsertUserClaim', payload);
            if (result && result.errors) {
                console.log(result.errors);
            } else {
                setClaimValue('');
                setClaimSearchText('');
                setClaimSuggestions([]);
                setSelectedSuggestion(null);
                await loadData(false);
            }
        }
        catch (e) {
            console.log(e);
        }
        finally {
            setIsLoading(false);
        }
    };

    const searchClaimTargets = async (searchText) => {
        try {
            setIsSearchingSuggestions(true);
            const result = await httpClient('get', 'User/GetClaimTargetSuggestions', {
                claimObject: claimObject,
                search: searchText || '',
                take: 15
            });
            setClaimSuggestions(result || []);
        }
        catch (e) {
            console.log(e);
            setClaimSuggestions([]);
        }
        finally {
            setIsSearchingSuggestions(false);
        }
    };

    return (
        <Loader isLoading={isLoading}>
            <Container>
                <div className={classes.formBox}>
                    <Grid container spacing={1} alignItems="center">
                        <Grid item xs={12} md={3}>
                            <TextField
                                select
                                fullWidth
                                size="small"
                                label="Objet"
                                value={claimObject}
                                onChange={(e) => setClaimObject(e.target.value)}
                            >
                                <MenuItem value="league">Ligue</MenuItem>
                                <MenuItem value="team">Équipe</MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <TextField
                                select
                                fullWidth
                                size="small"
                                label="Permission"
                                value={permission}
                                onChange={(e) => setPermission(e.target.value)}
                            >
                                <MenuItem value="write">Écriture</MenuItem>
                                <MenuItem value="read">Lecture</MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Autocomplete
                                options={claimSuggestions}
                                getOptionLabel={(option) => option && option.label ? option.label : ''}
                                getOptionSelected={(option, value) => option && value && option.value === value.value}
                                loading={isSearchingSuggestions}
                                value={selectedSuggestion}
                                onChange={(e, value) => {
                                    setSelectedSuggestion(value);
                                    setClaimValue(value && value.value ? String(value.value) : '');
                                }}
                                inputValue={claimSearchText}
                                onInputChange={(e, value) => setClaimSearchText(value || '')}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        fullWidth
                                        size="small"
                                        label={claimObject === 'team' ? "Équipe (Ligue)" : "Ligue"}
                                        placeholder={claimObject === 'team' ? "Tapez le nom d'équipe..." : "Tapez le nom de ligue..."}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <Button
                                fullWidth
                                variant="contained"
                                color="primary"
                                onClick={handleAddClaim}
                                disabled={!String(claimValue || '').trim()}
                            >
                                Ajouter
                            </Button>
                        </Grid>
                    </Grid>
                </div>

                {
                    (rows ? rows : []).map((x, i) =>
                        <List
                            key={i}
                            component="nav"
                        >
                            <ListItem
                                button
                                divider
                                onClick={() => setSelected(i)}
                            >

                                <ListItemAvatar>
                                    <Avatar
                                        src={x.picture}
                                    />
                                </ListItemAvatar>

                                <ListItemText
                                    primary={
                                        <Typography noWrap>
                                            {x.description}
                                        </Typography>
                                    }
                                    secondary={x.claimType}
                                />
                                <ListItemSecondaryAction onClick={(e) => handleDelete(e, i, x, x.userID)}>
                                    <DeleteIcon
                                        edge="end"
                                    />
                                </ListItemSecondaryAction>
                            </ListItem>
                        </List>
                    )
                }
            </Container>
        </Loader >

    )
}
export default UserClaims
